import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DeviceActionProps,
  DeviceActionStepsProps,
} from '@components/Actions/ActionsModal/types';
import DatePicker from '@components/DatePicker';
import moment from 'moment';
import ActionTypes from '@utils/deviceActions';
import { Form, FormInstance } from 'antd';
import { IDevice } from '@pages/Assets/Inventory/types';

interface NetworkUnlockPayloadProps {
  action: ActionTypes.NETWORK_UNLOCK;
  devices: {
    msisdn: string;
    processData: string; // '{"dtDesbloqueio":"20240119"}';
  }[];
}

interface NetworkUnlockProps {
  devices: IDevice[];
  form: FormInstance<any>;
  isUpload?: boolean;
}

const useNetworkUnlock = ({
  devices,
  form,
  isUpload,
}: NetworkUnlockProps): DeviceActionProps => {
  const { t } = useTranslation('attributes');
  const unlockDate = Form.useWatch('unlockDate', form);

  const steps: DeviceActionStepsProps[] = useMemo(
    () => [
      {
        title: t('unlockDate'),
        name: 'unlockDate',
        initialValue: moment(),
        content: (
          <DatePicker
            defaultValue={moment()}
            disabledDate={current => {
              return (
                current && current.startOf('day') < moment().startOf('day')
              );
            }}
            style={{ maxWidth: '214px', width: '100%' }}
          />
        ),
      },
    ],
    [t],
  );

  const unlockDateFormatted = useMemo(
    () => unlockDate?.format('YYYYMMDD'),
    [unlockDate],
  );

  const payloadToSend = useMemo(
    (): NetworkUnlockPayloadProps => ({
      action: ActionTypes.NETWORK_UNLOCK,
      devices: devices?.map(device => ({
        msisdn: device.msisdn,
        processData: JSON.stringify({
          dtDesbloqueio: isUpload ? device.processData : unlockDateFormatted,
        }),
      })),
    }),
    [devices, isUpload, unlockDateFormatted],
  );

  return {
    steps,
    payloadToSend,
  };
};

export default useNetworkUnlock;
